﻿import { IMaterial, IMaterialGroup } from "../../interfaces";

export const Sort = {
    materials: (materials: IMaterial[]) => {
        materials.sort((a, b) => (((a.l3 as any) + (a.materialId as any)) > ((b.l3 as any) + (b.materialId as any))) ? 1 :
            ((((b.l3 as any) + (b.materialId as any)) > ((a.l3 as any) + (a.materialId as any))) ? -1 : 0));
    },
    materialGroups: (materialGroups: IMaterialGroup[]) => {
        materialGroups.sort((a, b) => (((a.subtitle as any) + (a.id as any)) > ((b.subtitle as any) + (b.id as any))) ? 1 :
            ((((b.subtitle as any) + (b.id as any)) > ((a.subtitle as any) + (a.id as any))) ? -1 : 0));
    }
};
